import classNames                                 from 'classnames';
import * as React                                 from 'react';
import { useTranslation }                         from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import DV                                         from 'ts-data-validator';

import { useCatalog } from '../../providers/catalog';
import { useCommon }  from '../../providers/common';

import Accordion                  from '../accordion/Accordion';
import RenderButton               from '../buttons/base/RenderButton';
import RenderCheckboxButtonsGroup from '../fields/checkbox/RenderChecboxButtonsGroup';
import RenderCheckboxGroup        from '../fields/checkbox/RenderCheckboxGroup';
import RenderRadioGroup           from '../fields/radioButton/RenderRadioGroup';
import RenderBaseRangeSlider      from '../fields/rangeSlider/RenderBaseRangeSlider';
import RenderMagnetRangeSlider    from '../fields/rangeSlider/RenderMagnetRangeSlider';
import SingleSelect               from '../fields/select/SingleSelect';
import FilterIcon                 from '../icons/FilterIcon';

const CatalogFilter = function(props) {
  const history  = useHistory();
  const location = useLocation();
  const match    = useRouteMatch();
  const { t }    = useTranslation();

  const {
          resetPagination,
          selectedValues,
        } = props;

  const catalog = useCatalog();

  const isUpdatingFilterRef = React.useRef(false);

  const handleSetFilterParam = React.useCallback((url, param, value) => {
    if (isUpdatingFilterRef.current) {
      return;
    }

    const currentValue = catalog.filter.selectedValues[param];

    const isSameValue = (DV.isNull(value) || DV.isUndefined(value))
      ? (DV.isNull(currentValue) || DV.isUndefined(currentValue))
      : !DV.isArray(currentValue)
        ? Number(currentValue) === Number(value)
        : false;

    if (isSameValue) {
      return;
    }

    isUpdatingFilterRef.current = true;

    catalog.setFilterParam(url, param, value)
      .then(() => {
        resetPagination();
      })
      .finally(() => {
        isUpdatingFilterRef.current = false;
      });
  }, [catalog.filter.selectedValues, resetPagination]);
  const renderComponent      = React.useCallback((item, index) => {
    let selected;

    switch (item.component) {
      case 'select':
        return (
          <SingleSelect
            key={index}
            onChangeCallback={(value) => {
              handleSetFilterParam(`${location.pathname}${location.search}`, item.query_key, value);
            }}
            options={item.options}
            selected={+catalog.filter.selectedValues[item.query_key]}
          />
        );

      case 'checkboxButtons':
        return (
          <RenderCheckboxButtonsGroup
            data={props[item.query_key]}
            key={index}
            onChange={(queryKey, value) => {
              handleSetFilterParam(`${location.pathname}${location.search}`, queryKey, value);
            }}
            selectedValues={catalog.filter.selectedValues}
          />
        );

      case 'checkboxGroup':
        return (
          <RenderCheckboxGroup
            data={item.options}
            facets={item.facets}
            key={index}
            onChange={(value) => {
              handleSetFilterParam(`${location.pathname}${location.search}`, item.query_key, value);
            }}
            selectedValues={catalog.filter.selectedValues[item.query_key] || []}
          />
        );

      case 'BaseRangeSlider':
        selected = catalog.filter.selectedValues[item.query_key]
          ? catalog.filter.selectedValues[item.query_key].split('_')
          : [item.options[0], item.options[item.options.length - 1]];

        return (
          <RenderBaseRangeSlider
            data={item.options}
            key={index}
            onChange={(value) => {
              handleSetFilterParam(`${location.pathname}${location.search}`, item.query_key, `${value.min}_${value.max}`);
            }}
            value={{
              max: +selected[1],
              min: +selected[0],
            }}
          />
        );

      case 'magnetRangeSlider':
        selected = catalog.filter.selectedValues[item.query_key]
          ? selectedValues[item.query_key].split('_')
          : [item.options[0], item.options[item.options.length - 1]];

        return (
          <RenderMagnetRangeSlider
            data={item.options}
            key={index}
            onChange={(value) => {
              handleSetFilterParam(`${location.pathname}${location.search}`, item.query_key, `${value.min}_${value.max}`);
            }}
            step={item.query_key === 'mt' ? 0.1 : 1}
            value={{
              min: +selected[0],
              max: +selected[1],
            }}
          />
        );

      case 'radioButtons':
        return (
          <RenderRadioGroup
            alwaysEnabled={item.alwaysEnabled}
            facets={item.facets}
            key={index}
            options={item.options}
            queryKey={item.query_key}
            setFilterHandler={(value) => {
              handleSetFilterParam(`${location.pathname}${location.search}`, item.query_key, value);
            }}
            selectedValues={catalog.filter.selectedValues}
          />
        );

      default:
        return (
          <div key={index}>
            label: {item.label}<br />
            form type: {item.component}
          </div>
        );
    }
  }, [handleSetFilterParam, location.pathname, location.search, catalog.filter.selectedValues, match.params.page]);

  return (
    <aside
      id={'filter'}
      className={classNames({ open: catalog.filter.open })}
    >
      <div className={'filter-body'}>
        <div
          className={'btn-filter'}
          onClick={() => {
            if (catalog.filter.open) {
              catalog.hideFilter();
            } else {
              catalog.showFilter();
            }
          }}
        >
          <span className={'title'}>{t('client_filter')}</span>
          <FilterIcon />
        </div>
        <section className={'body'}>
          {catalog.filter.filter.body && catalog.filter.filter.body
            .map((item, index) => {
              if (item.query_key === 'pr') {
                return null;
              }

              if (match.params.page === 'vhodnye-dveri' && item.query_key === 'ct') {
                return null;
              }

              return (
                <Accordion
                  key={index}
                  title={item.labelIsTranslationKey === false ? item.label : t(`client_${item.label}`)}
                >
                  <div className={'body'}>
                    {renderComponent(item, index)}
                  </div>
                </Accordion>
              );
            })}
        </section>
      </div>
      <RenderButton
        action={() => {
          history.push(`/${match.params.page}`);

          catalog.resetFilter();
          catalog.getCatalogItems(`/${match.params.page}`);
        }}
        className={'bottom'}
        label={t('client_reset_filter')}
      />
    </aside>
  );
};
export default CatalogFilter;